import { EMPTY } from "rxjs";
import { filter, switchMap } from "rxjs/operators";
import { logNetworkIn, warnNetworkIn } from "../../utils/logging/logging";
import { CommandCode, StatusCode } from "../../utils/network/generated/protoTypes";
var defaultHandler = function (state, deps) { return function (props, statusCode) {
    warnNetworkIn("Notice not handled [" + statusCode + "]:", props);
    return EMPTY;
}; };
export var createEpicNetworkNotices = function (networkStreamSelector, handlerMap) { return function (action$, state$, deps) {
    return networkStreamSelector(deps).pipe(filter(function (res) { return res.sequenceNumber === -1; }), switchMap(function (res) {
        logNetworkIn(res.id + " <-\uFE0E <" + StatusCode[res.statusCode] + "> [" + CommandCode[res.id] + "#" + res.sequenceNumber + "]", res.props);
        return (handlerMap.get(res.id) || defaultHandler)(action$, state$, deps)(res.props, res.statusCode);
    }));
}; };



//////////////////
// WEBPACK FOOTER
// ./src/features/network/createEpicNetworkNotices.ts
// module id = 2004
// module chunks = 3